/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_DescriptionInputs */

const en_changelog_description = /** @type {(inputs: Changelog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crazy Frog AI release notes for AI video and image tools, credits, and generation history.`)
};

const es_changelog_description = /** @type {(inputs: Changelog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de versión de Crazy Frog AI sobre herramientas de video e imagen con IA, créditos e historial.`)
};

/**
* | output |
* | --- |
* | "Crazy Frog AI release notes for AI video and image tools, credits, and generation history." |
*
* @param {Changelog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const changelog_description = /** @type {((inputs?: Changelog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_changelog_description(inputs)
	return es_changelog_description(inputs)
});